<template>
  <div>
<div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>
    <div class="d-flex">
      <feather-icon icon="UserIcon" size="19" />
      <h4 class="mb-0 ml-50">
        {{ $t('Linke Geufences to devce') }}-{{deviceData.name}}
      </h4>

       <table-widget v-if="Object.keys(allItems).length!==0" 
       :items="allItems" 
        :selected_ids="selectedItems" 
         :fields="fields" 
          link_type="deviceDrivers"
           :link_to_id="deviceData.device_id"
            title="title" />
    </div>



  </div>

</template>

<script>

import {
  BButton, BCol,
  BFormGroup,
  BFormInput,
  BInputGroup, BInputGroupPrepend, BRow, BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { ref, onMounted, on, onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import TableWidget from '@/views/widgets/TableWidget.vue';


import { ReportService } from '@/app/reports/share/report.service'
import store from '@/store'
export default {
  props: {
    deviceData: {
      type: Object,
      required: true
    },

  },
  directives: {
    Ripple,
  },
  components: {
    BRow,

    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    vSelect,
    OrbitSpinner,
    TableWidget
  },

  setup(props, { root }) {
  const loading=ref(true)
  const fields =ref([[{key:'id',label:'id'}]])
  const allItems=ref([]);
  const selectedItems=ref([]);

  ReportService.getAreasOptions({
    type:'driver',
    user: store.state.auth.userData.id
  }).then(response =>{ 
    allItems.value = replaceIdWithDriverId(response.data)

  
     loading.value=false
    })
  const replaceIdWithDriverId=(data)=>{
   const out= data.map((d)=>({id:d.driver_id,name:d.name}))
 
     return out ;

  }

  ReportService.getSelectedLinks({
    type:'deviceDrivers',
    deviceId:props.deviceData.device_id
  }).then(response => { 
    selectedItems.value = response.ids
   
   
    
  })




   const getData =()=>{
   //console.log("get data",allItems.value)

   }
   getData();
    return {
      getData,
      allItems,
      fields,
      selectedItems,
      loading,
    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
